import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApiHelper } from "../../../utils/apiHelper";
import { toast } from "react-toastify";

// Fetch işlemi için yeni thunk
export const fetchProjectDetails = createAsyncThunk(
    "startup/fetchProjectDetails",
    async (startupId, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.get(`/startup/${startupId}/product-details`);
            if (response.data.code === "00000") {
                console.log(response.data.startupProductProjectDetails);
                return response.data.startupProductProjectDetails;
            } else {
                throw new Error("Project details fetch failed");
            }
        } catch (error) {
            return rejectWithValue(error.message || "An error occurred");
        }
    }
);

export const updateProjectDetails = createAsyncThunk(
    "startup/updateProjectDetails",
    async (projectDetails, { rejectWithValue, dispatch }) => {
        try {
            const response = await ApiHelper.put("/startup/product-details", projectDetails);
            if (response.data.code === "00000") {
                toast.success("Ürün/Proje detayı başarıyla güncellendi");
                // Güncelleme başarılı olduktan sonra yeni verileri fetch et
                await dispatch(fetchProjectDetails(projectDetails.startupId));
                return projectDetails;
            } else {
                throw new Error("Project details update failed");
            }
        } catch (error) {
            return rejectWithValue(error.message || "An error occurred");
        }
    }
);

const projectDetailsSlice = createSlice({
    name: "projectDetails",
    initialState: {
        projectDetails: null,
        loading: false,
        error: null,
    },
    reducers: {
        update: (state, action) => {
            state.projectDetails = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProjectDetails.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchProjectDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.projectDetails = action.payload;
                state.error = null;
            })
            .addCase(fetchProjectDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(updateProjectDetails.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateProjectDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.projectDetails = action.payload;
                state.error = null;
            })
            .addCase(updateProjectDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { update } = projectDetailsSlice.actions;
export default projectDetailsSlice.reducer;
